import {put,takeLatest,call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    GET_VENUE_BY_ID,
    GET_VENUE_BY_ID_SUCCESS,
    GET_VENUE_BY_ID_ERROR
}
    from "../../actions/venue";

function* getVenueByIdSaga(action) {
    try {
        const data=yield call(venueService.GetVenueById,action.payload)
        yield put({
            type: GET_VENUE_BY_ID_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_VENUE_BY_ID_ERROR,error: error.data
        });
    }
}


export function* getVenueByIdSagaWatcher() {
    yield takeLatest(GET_VENUE_BY_ID,getVenueByIdSaga);
}